export default "__VITE_ASSET__cd69ffe4__"